import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { updateUserDetails } from "../../store/Slice/loginSlice";
import Button from "../../components/shared/Button";
import { useNavigate } from "react-router-dom";
import { generateRandomDots } from "../../utils";
import { ApiService } from "../../services/apiService";
import { toast } from "react-toastify";

const ChangePasswordCam = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const email = localStorage.getItem("campaignEmail");
  const username = email.split("@")[0];
  const initialValues = {
    user_name: username,
    password: "",
    confirm_password: "",
    email: email,
  };

  const validationSchema = Yup.object().shape({
    user_name: Yup.string().required("Username is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const handlePasswordChange = async (values, { resetForm }) => {
    try {
      setIsLoading(true);
      const response = await ApiService.userCampaignLogin(values);
      if (response.data.code === 200 || response.data.code === 201) {
        const token =
          response.headers.authorization || response.headers.Authorization;
        localStorage.setItem("token", token);
        localStorage.setItem("tokenTimestamp", Date.now().toString());
        toast.success("Welcome, you have successfully logged in.");
        setTimeout(() => {
          dispatch(updateUserDetails());
          navigate("/ig_real_oganic_likes");
          setIsLoading(false);
        }, 3000);
        resetForm();
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error.response.data.message);
    }
  };

  const dots = generateRandomDots(50);

  return (
    <div className="relative flex min-h-screen justify-center items-center px-4 py-6 bg-[#f5f6fa]">
      {dots.map((dot) => (
        <span
          key={dot.id}
          className="absolute bg-[#001f68] rounded-full"
          style={{
            width: dot.size,
            height: dot.size,
            top: dot.top,
            left: dot.left,
            opacity: Math.random() * 0.8 + 0.2,
          }}
        ></span>
      ))}
      <div className="space-y-8">
        <div className="text-center">
          <p className="font-bold font-Montserrat text-6xl lg:text-5xl md:text-5xl sm:text-3xl xs:text-3xl bg-gradient-to-r from-yellow-500  via-[#001f68] to-yellow-600 bg-clip-text text-transparent">
            Welcome to
          </p>
          <p className="text-8xl lg:text-6xl md:text-6xl sm:text-4xl xs:text-4xl italic font-semibold text-yellow-600">
            Igcarts
          </p>
        </div>
        <div className="w-full max-w-lg px-4 bg-white rounded-md shadow-md">
          <p className="text-center text-[#001f68] font-FiraSans font-semibold text-2xl py-3">
            Input a new password and continue
          </p>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handlePasswordChange}
          >
            {({ handleSubmit, isValid }) => (
              <Form className="px-8 py-4 z-50" onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label
                    htmlFor="user_name"
                    className="block text-black text-sm font-FiraSans font-bold mb-2"
                  >
                    Username
                  </label>
                  <Field
                    type="text"
                    name="user_name"
                    id="user_name"
                    placeholder="Enter your username"
                    className={`shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline ${
                      isValid ? "border-gray-300" : "border-red-500"
                    }`}
                  />
                  <ErrorMessage
                    name="user_name"
                    component="p"
                    className="text-red-500 text-sm italic"
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="password"
                    className="block text-black text-sm font-FiraSans font-bold mb-2"
                  >
                    Password
                  </label>
                  <Field
                    type="password"
                    name="password"
                    id="password"
                    placeholder="Enter password"
                    className={`shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline ${
                      isValid ? "border-gray-300" : "border-red-500"
                    }`}
                  />
                  <ErrorMessage
                    name="password"
                    component="p"
                    className="text-red-500 text-sm italic"
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="confirm_password"
                    className="block text-black text-sm font-FiraSans font-bold mb-2"
                  >
                    Confirm Password
                  </label>
                  <Field
                    type="password"
                    name="confirm_password"
                    id="confirm_password"
                    placeholder="Confirm password"
                    className={`shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline ${
                      isValid ? "border-gray-300" : "border-red-500"
                    }`}
                  />
                  <ErrorMessage
                    name="confirm_password"
                    component="p"
                    className="text-red-500 text-sm italic"
                  />
                </div>

                <div className="flex items-center justify-center mt-6">
                  <Button
                    type="submit"
                    title={isLoading ? "Signing in..." : "Continue"}
                    variant={isValid ? "secondary" : "disabled"}
                    disabled={!isValid || isLoading}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordCam;
